// Terms of Service Configuration
export const CURRENT_TOS_VERSION = '1.0';

// ToS URLs by language
export const TOS_URLS = {
  en: '/legal/terms-of-service',
  ko: '/legal/terms-of-service',
} as const;

// Privacy Policy URLs by language
export const PRIVACY_URLS = {
  en: '/legal/privacy-policy',
  ko: '/legal/privacy-policy',
} as const;
